import { ActiveUserProducer } from 'types/types.type';
import { Organization } from 'types/organization.type';
import React, { ReactFragment } from 'react';
import { BaseActiveProducer } from './BaseActiveProducer';

// TODO even though this will implement all of the members should it extend BaseProducer?
export class NullActiveProducer extends BaseActiveProducer {
    getAvailableProducers(): Organization[] {
        return [];
    }
    getCreateSubmissionSubHeader(assignedProducer: Organization, doSelectProducer: () => void): ReactFragment {
        return '';
    }
    getEffectiveActiveProducer(): Organization | undefined {
        return undefined;
    }
    async fetchAvailableAgents(): Promise<void> {
        return new Promise<void>((res) => {
            res();
        });
    }

    getProducer(): Organization {
        return {} as Organization;
    }

    getId(): string | undefined {
        return undefined;
    }

    validateAssignedProducer(assignedProducer: Organization): Organization | undefined {
        return undefined;
    }

    getTemplateQualifier(fileType: string, availableQualifiers: string[] | undefined): string {
        return '';
    }
}
